import FullPageLoader from '../../src/common/FullPageLoader';
import React, { useEffect, useState, useMemo } from 'react';
import RemittanceListTable from './RemittanceListTable';
import RemittanceListFilter from './RemittanceListFilter';
import { getRemittanceList,downloadSoa,bulkRemittanceAssignee,saveRemittancePayment } from '../../src/store/slices/remittance';
import { useDispatch } from 'react-redux';
import { getMasterConfig, getPartnerList } from '../../src/store/slices/common';
import { useLanguage } from '../../src/context/LanguageContext';
import { getRoleListing } from '../../src/store/slices/RoleUser';
import { toast } from "react-toastify";
import * as HELPER from "../../src/config/helper";
import secureStorage from "@src/config/encrypt";
import {LEAD_ASSIGN_TO,MAX_LEAD_ASSIGN_COUNT,ROLE_SLUG_MAP,COUNTRY_CODE,APP_COUNTRY,OPS_ROLE_ID,MAKER_ROLE_ID,CHECKER_ROLE_ID,LEAD_REMITTANCE_STATUS_MARK} from '../../src/config/constant';
import ConfirmPopup from '../../src/common/ConfirmPopUp';
import PaymentInfoPopup from '../../src/lead/common/PaymentInfoPopup';
import LeadAssigneePopup from '../../src/lead/common/LeadAssignPopup';
import BulkPayoutResultPopup from './BulkPayoutResultPopup';
import { useSelector } from 'react-redux';
// import SoaExport from './SoaExport';
interface SelectedLead {
  lead_id: number;
  remittance_status: number | null;
  remittance_type_id: number | null;
  remittance_type_name?: string | null;
  assign_to?: string;
}

interface RemittanceListState {
  filters: Record<string, any>;
  page_number: number;
}

const REMITTANCE_LIST_STORAGE_KEY = 'remittance_list_state';
const REMITTANCE_VIEW_ROLES = ["REM_OPS", "REM_FINANCE_MAKER", "REM_FINANCE_CHECKER"];
const remittanceViewChips = [
    { key: 'all', label: 'All Remittance' },
    { key: 'my', label: 'My Remittance' },
];

const formatRemittanceCount = (count: any) => {
    const numericCount = Number(count || 0);
    return Number.isFinite(numericCount) ? numericCount.toLocaleString('en-US') : '0';
};

const sanitizeRemittanceFilters = (params: Record<string, any> = {}) => {
    const filters = { ...params };
    delete filters.apiType;
    delete filters.page_no;
    delete filters.page_number;
    delete filters.callingFrom;
    delete filters.isResetFilters;
    return filters;
};

const getStoredRemittanceListState = (): RemittanceListState => {
    if (typeof window === 'undefined') {
        return { filters: {}, page_number: 1 };
    }

    try {
        const storedState = sessionStorage.getItem(REMITTANCE_LIST_STORAGE_KEY);
        if (!storedState) {
            return { filters: {}, page_number: 1 };
        }

        const parsedState = JSON.parse(storedState);
        return {
            filters: parsedState?.filters && typeof parsedState.filters === 'object' ? parsedState.filters : {},
            page_number: Number(parsedState?.page_number) > 0 ? Number(parsedState.page_number) : 1
        };
    } catch (error) {
        return { filters: {}, page_number: 1 };
    }
};

const persistRemittanceListState = (filters: Record<string, any>, pageNumber: number) => {
    if (typeof window === 'undefined') {
        return;
    }

    const normalizedPageNumber = Number(pageNumber) > 0 ? Number(pageNumber) : 1;
    if (normalizedPageNumber === 1 && Object.keys(filters || {}).length === 0) {
        sessionStorage.removeItem(REMITTANCE_LIST_STORAGE_KEY);
        return;
    }

    sessionStorage.setItem(
        REMITTANCE_LIST_STORAGE_KEY,
        JSON.stringify({
            filters,
            page_number: normalizedPageNumber
        })
    );
};


const RemittanceList: React.FC = () => {
    const insurerList = useSelector((state: any) => state.common.partner);
    const [loading, setLoading] = useState<boolean>(false);
    const [remittanceList, setRemittanceList] = useState<any>([]);
    const [paginationData, setPaginationData] = useState<any>({});
    const dispatch: any = useDispatch();
    const [selectedFilters, setSelectedFilters] = useState<any>(() => getStoredRemittanceListState().filters);
    const [currentPage, setCurrentPage] = useState<number>(() => getStoredRemittanceListState().page_number);
    const [masterConfig, setMasterConfig] = useState<any>({});
    const {translations} = useLanguage();
    const [partnerList, setPartnerList] = useState<any>([]);
    const [assignUsers, setAssignedUsers] = useState<any>([]);
    const [selectedLeads, setSelectedLeads] = useState<SelectedLead[]>([]);
    const [showConfirmation, setShowConfirmation] = useState(false)
    const [confirmationMessage, setConfirmationMessage] = useState<string>(translations.Remittance?.["SAVE_DETAIL_CONFIRMATION"]);
    const [confirmationFrom, setConfirmationFrom] = useState<string>("InsurerPartnerRemittance")
    const [LeadAssignTo, setLeadAssignTo] = useState<string>("");
    const [remittanceType] = useState<string>("");
    const [callReloadApi, setCallReloadApi] = useState<number>(0);
    const [statusMark, setStatusMark] = useState<any>([]);
    const [viewPaymentInfo, setViewPaymentInfo] = useState(false);

    const [isAllLeadsSelected, setIsAllLeadsSelected] = useState<boolean>(false);
    const [showLeadAssignPopup,setShowLeadAssignPopup] = useState<boolean>(false);
    const [agentId,setAgentId] = useState<number>(0);
    const [filteredassignUsers, setFilteredAssignedUsers] = useState<any>([]);
    const [userRoleLabel,setUserRoleLabel] = useState<string>("");
    const [showAssignConfirmation, setShowAssignConfirmation] = useState(false);
    const [askForPayment, setAskForPayment] = useState<boolean>(false);
    const [callUpdateFunction,setCallUpdateFunction] = useState<boolean>(false);
    const [showBulkPayoutResult, setShowBulkPayoutResult] = useState<boolean>(false);
    const [bulkPayoutResult, setBulkPayoutResult] = useState<any>(null);
    const [selectedRemittanceView, setSelectedRemittanceView] = useState<string>("my");

    const isIdApp = COUNTRY_CODE === APP_COUNTRY.APP_TYPE_ID;
    const authUserInfo = secureStorage.getItem("authUserInfo");
    const roleName = HELPER.normalizeRoleName(authUserInfo?.user_data?.assigned_role_name || "");
    const loggedInUserId = authUserInfo?.user_data?.id;
    const isAdminLoggedIn = roleName === "ADMIN";
    const showRemittanceViewChips = REMITTANCE_VIEW_ROLES.includes(roleName);

    const partnerMap = useMemo(() => {
        const map: Record<number, { label: string; partner_name: string }> = {}; 
        insurerList.forEach((p: any) => { map[+p.value] = {
            label: p.label,
            partner_name: p.partner_name
        }; });
        return map;
    }, [insurerList]);

    const formatPartnerList = (data: any[] = []) => {
        return data.map((item: any) => ({
            ...item,
            isDisabled: false
        }));
    };

    const getRemittanceViewFilters = (filters: Record<string, any> = {}, remittanceView = selectedRemittanceView) => {
        const filtersWithView = { ...filters };

        if (!showRemittanceViewChips) {
            return filtersWithView;
        }

        if (remittanceView === 'my' && loggedInUserId) {
            filtersWithView.assign_user_id = loggedInUserId;
        } else {
            delete filtersWithView.assign_user_id;
        }

        return filtersWithView;
    };

    const getRemittanceViewChipCount = (chipKey: string) => {
        if (chipKey === 'all') {
            return paginationData?.all_remittance_count ?? paginationData?.total ?? 0;
        }

        return paginationData?.my_remittance_count ?? 0;
    };
    
    useEffect(() => {
        if (COUNTRY_CODE === APP_COUNTRY.APP_TYPE_ID && insurerList.length > 0) {
            getRemittanceListing({ page_number: currentPage });
        }
    }, [insurerList]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (insurerList.length > 0) {
            setPartnerList(formatPartnerList(insurerList));
        }
    }, [insurerList]);

    
    useEffect(() => {
        getMasterConfigApi();
        if (insurerList.length === 0) {
            getPartners();
        }
        // eslint-disable-next-line
        getAssignedUsers();
        if(COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH){
            getRemittanceListing({ page_number: currentPage });
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (callReloadApi > 0) {
            getRemittanceListing({ page_number: currentPage });
        }
    }, [callReloadApi]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (selectedLeads.length === 0 && isAllLeadsSelected) {
            setIsAllLeadsSelected(false);
        }
    }, [selectedLeads.length, isAllLeadsSelected]);


    //GET REMITTANCE LIST API
    const getRemittanceListing = (params: any = {},isCall=true, remittanceView = selectedRemittanceView) => {
        const sanitizedFilters = sanitizeRemittanceFilters(params);
        const appliedFilters = params?.isResetFilters
            ? {}
            : Object.keys(sanitizedFilters).length > 0
                ? sanitizedFilters
                : selectedFilters;
        const pageNumber = Number(params?.page_number ?? params?.page_no ?? currentPage ?? 1) || 1;

        setSelectedFilters(appliedFilters);
        setCurrentPage(pageNumber);
        persistRemittanceListState(appliedFilters, pageNumber);

        let filters = {
            apiType: 2, // 2 for remittance
            page_number: pageNumber,
            ...appliedFilters,
        }
        filters = getRemittanceViewFilters(filters, remittanceView);
        setLoading(true);
        dispatch(getRemittanceList(filters)).then((res: any) => {
            if (res && res.status === 200) {
                setLoading(false);
                setPaginationData(res.pagination);
                if (insurerList.length > 0 && COUNTRY_CODE === APP_COUNTRY.APP_TYPE_ID) {
                    const updatedData = res.data.map((item: any) => {
                        return {
                        ...item,
                        insurer_name: partnerMap[item.insurer_id]?.label || "",
                        partner_name: partnerMap[item.insurer_id]?.partner_name || ""
                        };
                    });
                    setRemittanceList(updatedData);
                }else{
                    setRemittanceList([...res.data])
                }
                if(isAllLeadsSelected && isCall){
                    const allSelected: SelectedLead[] = res.data.map((lead: any) => ({
                        lead_id: lead.leadId,
                        remittance_status: lead.remittance_status ?? null,
                        remittance_type_id: lead.remittance_type_id ?? null,
                        remittance_type_name : lead.remittance_type_slug ?? null,
                    }));
                    setSelectedLeads(allSelected);
                }else{
                    setSelectedLeads([])
                }
            }
        }).catch((err: Error) => {
            setLoading(false)
        })
    }

    const handleRemittanceViewChange = (remittanceView: string) => {
        if (selectedRemittanceView === remittanceView) return;
        setSelectedRemittanceView(remittanceView);
        setSelectedLeads([]);
        setIsAllLeadsSelected(false);
        getRemittanceListing({ page_number: 1, ...selectedFilters }, false, remittanceView);
    }

    //GET MASTER CONFIG API
    const getMasterConfigApi = () => {
        setLoading(true);
        dispatch(getMasterConfig()).then((res: any) => {
            if (res && res.status === 200) {
                if (res.data) {
                    setMasterConfig(res.data);
                }
            }
        }).catch((err: Error) => {
            setLoading(false);
        })
    }

    const getStatusMarkByRoleId = (roleId: number, preferredOrder: number[] = []) => {
        const roleStatusMark = (masterConfig?.remittance_status_mark || []).filter((item: any) => item.role_id === roleId);
        if (preferredOrder.length === 0) {
            return roleStatusMark;
        }

        return [...roleStatusMark].sort((a: any, b: any) => {
            const indexA = preferredOrder.indexOf(+a.value);
            const indexB = preferredOrder.indexOf(+b.value);
            const orderA = indexA === -1 ? preferredOrder.length : indexA;
            const orderB = indexB === -1 ? preferredOrder.length : indexB;
            return orderA - orderB;
        });
    };

    const openOpsConfirmation = () => {
        setStatusMark(getStatusMarkByRoleId(OPS_ROLE_ID));
        setConfirmationMessage(translations.Remittance?.["SEND_TO_MAKER_CONFIRMATION"]);
        setConfirmationFrom("SendToMaker");
        setLeadAssignTo(LEAD_ASSIGN_TO['REM_FINANCE_MAKER']);
        setShowConfirmation(true);
    };

    const openMakerConfirmation = () => {
        setStatusMark(
            getStatusMarkByRoleId(MAKER_ROLE_ID, [
                LEAD_REMITTANCE_STATUS_MARK['BACK_TO_OPS'],
                LEAD_REMITTANCE_STATUS_MARK['MAKE_PAYMENT']
            ])
        );
        setConfirmationMessage(translations.Remittance?.["SEND_TO_OPS_CONFIRMATION"]);
        setConfirmationFrom("SendToMaker");
        setLeadAssignTo(LEAD_ASSIGN_TO['REM_OPS']);
        setShowConfirmation(true);
    };

    const openCheckerConfirmation = () => {
        setStatusMark(getStatusMarkByRoleId(CHECKER_ROLE_ID));
        setConfirmationMessage(translations.Remittance?.["SEND_TO_MAKER_CONFIRMATION"]);
        setConfirmationFrom("SendToMaker");
        setLeadAssignTo(LEAD_ASSIGN_TO['REM_FINANCE_MAKER']);
        setShowConfirmation(true);
    };

    const hasOnlyStatuses = (statuses: number[]) => {
        return selectedLeads.every((lead) => lead.remittance_status !== null && statuses.includes(+lead.remittance_status));
    };

    const handleUpdate = () => {
        try{
            if(selectedLeads.length === 0){
                toast.error(translations.Remittance?.['NO_LEAD_SELECTED'] || translations.commonMsg?.loading);
                return;
            }
            const authUserInfo = secureStorage.getItem("authUserInfo");
            const roleId = authUserInfo?.user_data?.assigned_role_ids;
            const roleName = HELPER.normalizeRoleName(authUserInfo?.user_data?.assigned_role_name);
            let filteredData: any[] = [];
            switch (roleName) {
                case "REM_OPS":
                case "REM_FINANCE_MAKER":
                case "REM_FINANCE_CHECKER":
                    filteredData = masterConfig.remittance_status.filter((item: any) => item.role_id === roleId).map((item: any) => item.value);
                    const invalidLeads = selectedLeads.filter((lead) => !filteredData.includes(lead.remittance_status));
                    if (invalidLeads.length > 0) {
                        toast.error(translations.Remittance?.['STATUS_ARE_DIFFRENT'] || translations.commonMsg?.loading);
                    }else{
                        switch (roleName) {
                            case "REM_OPS":
                                openOpsConfirmation();
                            break;
                            case "REM_FINANCE_MAKER":
                                if (isIdApp) {
                                    openMakerConfirmation();
                                } else {
                                    setStatusMark(getStatusMarkByRoleId(roleId));
                                    setConfirmationMessage(translations.Remittance?.["SEND_TO_OPS_CONFIRMATION"]);
                                    setViewPaymentInfo(true);
                                }
                            break;
                            case "REM_FINANCE_CHECKER":
                                openCheckerConfirmation();
                            break;
                            default:
                                toast.error(translations.Remittance?.['ACTION_NOT_ALLOWED'] || translations.commonMsg?.loading);
                            break;
                        }
                    }
                    break;
                case "ADMIN":
                    toast.error("Action not allowed to admin");
                break;
                case "SALES_HEAD":
                    if (!isIdApp) {
                        toast.error(translations.Remittance?.['ACTION_NOT_ALLOWED'] || translations.commonMsg?.loading);
                    } else if (hasOnlyStatuses([3])) {
                        openMakerConfirmation();
                    } else {
                        toast.error(translations.Remittance?.['ACTION_NOT_ALLOWED'] || translations.commonMsg?.loading);
                    }
                break;
                default:
                    toast.error(translations.Remittance?.['ACTION_NOT_ALLOWED'] || translations.commonMsg?.loading);
                break;
            }
        }catch (error) {
            console.error("Error while updating status:", error);
        }finally {
            setLoading(false);
        }
    }

    const handleDownload = async () => {
        try{
            if(selectedLeads.length === 0){
                toast.error(translations.Remittance?.['NO_LEAD_SELECTED_SOA'] || translations.commonMsg?.loading);
                return;
            }
            setLoading(true);
            const payload = {
                bulk_update_leads: selectedLeads.map(({ remittance_status, remittance_type_id, ...rest }: any) => rest)
            }
            const response:any = await downloadSoa(payload);
            if (response?.status === 200) {
                setSelectedLeads([]);
            }
        }catch (error) {
            console.error("Error while updating status:", error);
        }finally {
            setLoading(false);
        }
    }

    const handleBulkPayout = async () => {
        try{
            if(selectedLeads.length === 0){
                toast.error(translations.Remittance?.['NO_LEAD_SELECTED'] || translations.commonMsg?.loading);
                return;
            }
            setAskForPayment(true);
        }catch (error) {
            console.error("Error while updating status:", error);
        }finally {
            setLoading(false);
        }
    }

    const getPartners = () => {
        dispatch(getPartnerList()).then((res: any) => {
            if (res && res.status === 200) {
                if (res.data) {
                    const data = Array.isArray(res?.data) ? res.data : [];
                    setPartnerList(formatPartnerList(data));
                }
            }
        }).catch((err: Error) => {
            setLoading(false);
        })
    }

    const getAssignedUsers = () => {
        dispatch(getRoleListing.getAssignedUsers({is_remittance:true})).then((res: any) => {
          if (res && res.status === 200) {
            setAssignedUsers(res.data.map((user: any) => { return { label: user.firstname, value: user.id,role_id:user.role_id,role_slug:user.role_slug } }));
          }
        }).catch((err: any) => {
          setLoading(false);
    
        })
    }

    const reloadDetail = async () => {
        setCallReloadApi((prev) => prev + 1);
    }

    const confirmYes = () => {
        setShowConfirmation(false);
    }

    const closePaymentPopup = () => {
        setCallUpdateFunction(false);
        setViewPaymentInfo(false);
    }

    const closeBulkPayoutResultPopup = () => {
        setShowBulkPayoutResult(false);
        setBulkPayoutResult(null);
        setSelectedLeads([]);
        setIsAllLeadsSelected(false);
        reloadDetail();
    }
    
    const updateBulkAssignee = () => {
        try{
            if(selectedLeads.length === 0){
                toast.error(translations.Insurance?.['NO_LEAD_SELECTED'] || translations.commonMsg?.loading);
                return;
            }
            if(isAllLeadsSelected){
                if (+paginationData.total > MAX_LEAD_ASSIGN_COUNT){
                    toast.error(`${translations.Insurance?.['MAX_ASSIGN_LEAD_LIMIT'] || translations.commonMsg?.loading} ${MAX_LEAD_ASSIGN_COUNT}`);
                    return;
                }
            }
            const assignTypes = selectedLeads.map((item:any) => item.assign_to);
            const uniqueAssignTypes = Array.from(new Set(assignTypes));
            if (uniqueAssignTypes.length > 1) {
                toast.error(`Please make sure that “Assigned to Role” is same for the selected leads`)
                return;
            }
            const selectedAssignType = uniqueAssignTypes[0];
            const roleSlug = ROLE_SLUG_MAP[selectedAssignType];
            const filteredUsers = assignUsers.filter((u: any) => u.role_slug === roleSlug);
            setFilteredAssignedUsers(filteredUsers);
            setUserRoleLabel(selectedAssignType);
            setShowLeadAssignPopup(true);
        }catch(error){
            console.error("Error In Update Assignee:", error);
        }
    }

     const handleSubmit = async () => {
        try{
            let paylaod:any = {
              lead_type:'remittance',
              assigned_user_id : +agentId,
              isAllLeadsSelected : isAllLeadsSelected,
              data_filter : getRemittanceViewFilters(selectedFilters)
            };
            if(!isAllLeadsSelected){
              paylaod.leads = selectedLeads
            }
            setLoading(true);
            const response:any = await bulkRemittanceAssignee(paylaod);
            if (response?.status === 200) {
              setShowAssignConfirmation(false)
              setSelectedLeads([]);
                let apiParams = {
                    ...selectedFilters
                }
                setIsAllLeadsSelected(false);
                getRemittanceListing(apiParams,false)
            }
          }catch (error) {
              console.error("Error while updating EMI detail:", error);
          }finally {
            // setLoading(false);
          }
      }

    const openPaymentConfirm = () => {
        setShowConfirmation(false);
        setAskForPayment(true);
    }

    const confirmPaymentUpdate = async () => {
        if (!isIdApp) {
            setAskForPayment(false);
            setCallUpdateFunction(true);
            return;
        }
        try {
            setLoading(true);
            const data = new FormData();
            data.append(
                "bulk_update_leads",
                JSON.stringify(selectedLeads.map(({ remittance_status, remittance_type_id, assign_to, ...rest }: any) => rest))
            );
            data.append("is_bulk_update", String(true));
            if(isAdminLoggedIn){
                data.append("isBulkPayout", String(true));
            }
            const response:any = await saveRemittancePayment(data);
            if (response?.status === 200) {
                setAskForPayment(false);
                if (isAdminLoggedIn) {
                    setBulkPayoutResult(response);
                    setShowBulkPayoutResult(true);
                } else {
                    setSelectedLeads([]);
                    setIsAllLeadsSelected(false);
                    reloadDetail();
                }
            }
        } catch (error) {
            console.error("Error while save Remittance Payment:", error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <FullPageLoader show={loading} />
            {showLeadAssignPopup && <LeadAssigneePopup from={"Remittance"} showLeadAssignPopup={showLeadAssignPopup} setShowLeadAssignPopup={setShowLeadAssignPopup} assignUsers={filteredassignUsers} setShowConfirmation={setShowAssignConfirmation} setAgentId={setAgentId} userRoleLabel={userRoleLabel}/>}
            {showAssignConfirmation === false ? ("") : (
                <ConfirmPopup
                    confirmNo={() => {
                        setShowAssignConfirmation(false);
                        setShowLeadAssignPopup(false);
                        setSelectedLeads([]);
                    }}
                    confirmYes={handleSubmit}
                    message={`All the ${isAllLeadsSelected === false ? selectedLeads.length : ''} records will get updated. Do you wish to continue ?`}
                    isConfirmNotVisible={true} 
                    from={"Remittance"}
                />
            )}
            {
                showConfirmation && 
                <ConfirmPopup
                    confirmNo={() => setShowConfirmation(false)}
                    confirmYes={confirmYes}
                    message={confirmationMessage}
                    isConfirmNotVisible={true} 
                    from={confirmationFrom}
                    LeadAssignTo={LeadAssignTo}
                    reloadDetail={reloadDetail}
                    selectedLeads={selectedLeads}
                    statusMark={statusMark}
                    setConfirmationMessage={setConfirmationMessage}
                    setLeadAssignTo={setLeadAssignTo}
                    onMakePaymentSelect={isIdApp ? openPaymentConfirm : undefined}>
                </ConfirmPopup>
            }
            {viewPaymentInfo && <PaymentInfoPopup viewPaymentInfo={viewPaymentInfo} handleViewPaymentInfo={closePaymentPopup} from={"RemittanceList"} remittanceType={remittanceType} reloadDetail={reloadDetail} selectedLeads={selectedLeads} statusMark={statusMark} message={confirmationMessage} setConfirmationMessage={setConfirmationMessage} onRequestConfirm={openPaymentConfirm} callUpdateFunction={callUpdateFunction} setCallUpdateFunction={setCallUpdateFunction}/>}
            {
                askForPayment && 
                <ConfirmPopup
                    confirmNo={() => setAskForPayment(false)}
                    confirmYes={confirmPaymentUpdate}
                    message={
                        <>
                            Are you sure you want to proceed with the bulk payment?
                            <br />
                            Once completed, this action cannot be undone.
                        </>
                    }
                    title={'Confirm Payment'}
                    from={'CONFIRM_PAYMENT'}
                    isConfirmNotVisible={false}>
                </ConfirmPopup>
            }
            <BulkPayoutResultPopup show={showBulkPayoutResult} handleClose={closeBulkPayoutResultPopup} result={bulkPayoutResult} remittanceList={remittanceList} />
            <div className='main-outer'>
                <div className="lead-list-outer container-fluid ">
                    <div>
                        <div className="top-heading top-heading-btn">
                            <h1>Remittance Listing</h1>
                            <div className='d-flex'>
                                <button className="btn-line btn-export" onClick={updateBulkAssignee}>
                                    {translations.Insurance?.['Update_Assignee'] || translations.commonMsg?.loading}
                                </button>
                                {
                                    !isAdminLoggedIn &&
                                    <button className="btn-line btn-export update-remittance-btn" onClick={handleUpdate}>
                                        <i className="ic-check m-sm-r"></i>
                                        {translations.Insurance?.['Update Remittance Status'] || translations.commonMsg?.loading}
                                    </button> 
                                }
                                {
                                    (isIdApp && isAdminLoggedIn) &&
                                    <button className="btn-line btn-export update-remittance-btn" onClick={handleBulkPayout}>
                                        <i className="ic-check m-sm-r"></i>
                                        {translations.Insurance?.['BULK-PAYOUT'] || translations.commonMsg?.loading}
                                    </button>
                                }
                                {/* <SoaExport/> */}
                                {
                                    (COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH) &&
                                    <button className="btn-line btn-export" onClick={handleDownload}>
                                        <i className="ic-save_alt m-sm-r"></i>
                                        {translations.Insurance?.['Download SOA'] || translations.commonMsg?.loading}
                                    </button>
                                }
                            </div>
                        </div>

                        <div className="loan-filter-bg remittance-list-filter">
                            <div className="top-filter-bg">
                                <p>Filters</p>
                                <RemittanceListFilter partnerList={partnerList} config={masterConfig} submitHandler={(filterParams: any) => { getRemittanceListing(filterParams) }} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} assignUsers={assignUsers}/>
                            </div>
                        </div>

                        <div className="lead-list-table-outer">
                            {showRemittanceViewChips && (
                                <div className="lead-view-chip-outer">
                                    <span className="lead-view-label">VIEW</span>
                                    <div className="lead-view-chip-list">
                                        {remittanceViewChips.map((chip) => (
                                            <button
                                                key={chip.key}
                                                type="button"
                                                className={`lead-view-chip ${selectedRemittanceView === chip.key ? 'active' : ''}`}
                                                onClick={() => handleRemittanceViewChange(chip.key)}
                                            >
                                                {chip.label}
                                                <span>{formatRemittanceCount(getRemittanceViewChipCount(chip.key))}</span>
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )}
                            <RemittanceListTable config={masterConfig} remittanceList={remittanceList} paginationData={paginationData} selectedFilters={selectedFilters} getRemittanceListing={getRemittanceListing} assignUsers={assignUsers} selectedLeads={selectedLeads} setSelectedLeads={setSelectedLeads} isAllLeadsSelected={isAllLeadsSelected} setIsAllLeadsSelected={setIsAllLeadsSelected}/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RemittanceList;
